import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Controller, useForm } from 'react-hook-form';
import { styles } from './styles';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    TextField,
    withStyles,
    makeStyles,
    IconButton,
    Typography
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { modalsButtonStyles } from '../../../collums-constants/styles/stylesheets/buttonsStyles';
import Button from '@material-ui/core/Button';
import customerApi from '../../../api/customerApi';

const FIELDS = [
    { key: 'campaignName', label: 'Campaign Name' },
    { key: 'campaignSource', label: 'Campaign Source' },
    { key: 'campaignMedium', label: 'Campaign Medium' },
    { key: 'campaignTerm', label: 'Campaign Term' },
    { key: 'campaignContent', label: 'Campaign Content' },
    { key: 'referralSource', label: 'Marketing Source' },
    { key: 'firstPageVisited', label: 'First Page Visited' },
    { key: 'gclid', label: 'GCLID' },
    { key: 'pageEnquiredThrough', label: 'Page Enquired Through' }
];

const MarketingDataModal = ({ open, onClose, classes, customer }) => {
    const globalStyles = makeStyles(modalsButtonStyles)();

    const defaultValues = {};
    FIELDS.forEach(({ key }) => {
        defaultValues[key] = '';
    });

    const { handleSubmit, errors, control, reset } = useForm({
        defaultValues: {
            ...defaultValues,
            ...FIELDS.reduce((acc, { key }) => {
                acc[key] = customer?.[key] || '';
                return acc;
            }, {})
        }
    });

    useEffect(() => {
        if (customer) {
            const values = {};
            FIELDS.forEach(({ key }) => {
                values[key] = customer[key] || '';
            });
            reset(values);
        }
    }, [customer, reset]);

    const saveHandler = useCallback(
        async values => {
            if (Object.keys(errors).length) return;

            try {
                await customerApi.update(customer.id, { ...customer, ...values });
            } finally {
                onClose();
            }
        },
        [customer, errors, onClose]
    );

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle className={classes.formDialogTitle}>
                <Typography className={`${classes.bold} ${classes.formDialogTitleLabel}`}>
                    Edit Marketing Data
                </Typography>
                <IconButton aria-label="close" onClick={onClose} className={classes.formDialogCloseButton}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.formDialogContent}>
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        handleSubmit(saveHandler)();
                    }}
                >
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <Grid container direction="column" spacing={2}>
                                {FIELDS.slice(0, 5).map(({ key, label }) => (
                                    <Grid item key={key}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name={key}
                                                control={control}
                                                render={({ value, onChange }) => (
                                                    <TextField
                                                        name={key}
                                                        variant="outlined"
                                                        label={label}
                                                        onChange={onChange}
                                                        value={value}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container direction="column" spacing={2}>
                                {FIELDS.slice(5).map(({ key, label }) => (
                                    <Grid item key={key}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name={key}
                                                control={control}
                                                render={({ value, onChange }) => (
                                                    <TextField
                                                        name={key}
                                                        variant="outlined"
                                                        label={label}
                                                        onChange={onChange}
                                                        value={value}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                    <div className={`${globalStyles.buttonsContainer}`}>
                        <Button className={`${globalStyles.cancelButton} ${classes.cancelButton}`} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button className={`${globalStyles.confirmButton} ${classes.confirmButton}`} type="submit">
                            Save
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};

MarketingDataModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(MarketingDataModal);
